import { createStreamEpic } from '../../signalr/createStreamEpic'
import { fetchBenchmarkDataDefinition } from './definition'

export default createStreamEpic(
  'benchmarkdata.fetch',
  fetchBenchmarkDataDefinition
)
